import { ofType } from "redux-observable";
import { merge } from "rxjs";
import { combineChecks } from "../../guards/combineChecks";
import { guard } from "../../guards/guard";
import { pathEmpty } from "../../guards/pathEmpty";
import { TypeActionBuildings } from "../../player-base/buildings/actionBuildings";
import { checkTutorialNextStepConfigExists } from "../checks/checkTutorialNextStepConfigExists";
import { checkTutorialProduceClickWindmill } from "../checks/checkTutorialProduceClickWindmill";
import { checkTutorialSowClickAcre } from "../checks/checkTutorialSowClickAcre";
import { checkTutorialSowClickOnRecipe } from "../checks/checkTutorialSowClickOnRecipe";
import { pathTutorialUpdate } from "../path/pathTutorialUpdate";
import { pathTutorialUpdateViewport } from "../path/pathTutorialUpdateViewport";
export var epicTutorialOnBuildingSelect = function (action$, state$, deps) {
    var actionProduceClickWindmill$ = action$.pipe(ofType(TypeActionBuildings.PreSelect), guard(state$, deps, pathEmpty)([
        combineChecks([checkTutorialNextStepConfigExists, checkTutorialProduceClickWindmill])(pathTutorialUpdateViewport),
    ]));
    var actionSowClickAcre$ = action$.pipe(ofType(TypeActionBuildings.PreSelect), guard(state$, deps, pathEmpty)([
        combineChecks([checkTutorialNextStepConfigExists, checkTutorialSowClickAcre])(pathTutorialUpdateViewport),
    ]));
    var actionSowClickOnRecipe$ = action$.pipe(ofType(TypeActionBuildings.PreSelect), guard(state$, deps, pathEmpty)([
        combineChecks([checkTutorialNextStepConfigExists, checkTutorialSowClickOnRecipe])(pathTutorialUpdate),
    ]));
    return merge(actionProduceClickWindmill$, actionSowClickAcre$, actionSowClickOnRecipe$);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/epics/epicTutorialOnBuildingSelect.ts
// module id = 2478
// module chunks = 3